import { z } from 'zod';

import { RequestKindSchema } from './kind.js';
import { RequestStatus } from './status.js';

export const REQUEST_PUBLIC_CODE_REGEX = /^LR-\d{5}$/;

/**
 * @aiPurpose typed cross-link fallback projection for a China `Request`
 *   shown to an actor who cannot see the full row (#1077). Mirrors the
 *   shape of `LeadFallbackSchema` for the lead-side fallback so a
 *   client-side cross-link card can switch on `entityKind` without
 *   touching PII.
 * @aiSecurity per the cross-link allowlist, fallback exposes ONLY
 *   `entityKind`, `publicCode`, `status`, and the non-PII discriminator
 *   `kind`. Never includes `name`, `route`, addresses, attachments,
 *   chat, audit, items, boxes, manager identity, or any other PII /
 *   business detail.
 * @aiInvariant `.strict()` rejects any extra key — the cross-link
 *   payload MUST fail loudly if a server-side mistake tries to pipe a
 *   richer surface through this projection.
 */
export const RequestFallbackSchema = z
  .object({
    entityKind: z.literal('china_request'),
    publicCode: z.string().regex(REQUEST_PUBLIC_CODE_REGEX),
    status: z.nativeEnum(RequestStatus),
    kind: RequestKindSchema.optional(),
  })
  .strict();
export type RequestFallback = z.infer<typeof RequestFallbackSchema>;
